import {
  calendar
} from '../constants';

/**
   * Import constants
   */
const {
  SET_EVENT_DAY,
  SET_LAST_VISITED_MONTH_VALUE
} = calendar;

/**
 * Action creators
 */
const actions = {
  setEventInfo: (data) => ({ type: SET_EVENT_DAY, data }),
  setLastVisitedMonthValue: (data) => ({ type: SET_LAST_VISITED_MONTH_VALUE, data }),
};

const setEventInfo = (eventInfo) => (dispatch) => dispatch(
  actions.setEventInfo(eventInfo)
);

const setLastVisitedMonthValue = (month) => (dispatch) => dispatch(
  actions.setLastVisitedMonthValue(month)
);

export {
  setEventInfo,
  setEventInfo as default,
  setLastVisitedMonthValue
};
